import { Outlet, type RouteObject } from "react-router-dom";
import EmpaForm from "src/empa/features/ui/EmpaForm";
import RouteProtector from "./RouteProtector";

export const empaPaths: RouteObject = {
  path: "/empa",
  element: <Outlet />,
  children: [
    {
      path: "form",
      element: (
        <RouteProtector allowedUsers={["isBusiness"]}>
          <EmpaForm />
        </RouteProtector>
      ),
    },
  ],
};
